import api from './client';

// --- Stripe Connect Express (Phase 7 + Phase 13) ---

export const stripeOnboard = async () => {
  const res = await api.post('/payouts/onboard', { origin: window.location.origin });
  return res.data;
};

export const stripeMockComplete = async () => {
  const res = await api.post('/payouts/onboard/mock-complete');
  return res.data;
};

export const stripeRefresh = async () => {
  const res = await api.post('/payouts/onboard/refresh');
  return res.data;
};

/** Stripe Express Dashboard one-time login link (for "Manage Stripe account"). */
export const stripeDashboardLink = async () => {
  const res = await api.post('/payouts/dashboard-link');
  return res.data;
};

// --- Phase 13: admin monetization controls ---

export const adminSuspendMonetization = async (userId) => {
  const res = await api.post(`/admin/users/${userId}/monetization/suspend`);
  return res.data;
};

export const adminResumeMonetization = async (userId) => {
  const res = await api.post(`/admin/users/${userId}/monetization/resume`);
  return res.data;
};

// Phase 17 — RBAC role management + email log enrichment
export const adminSetUserRole = async (userId, role) => {
  const res = await api.post(`/admin/users/${userId}/role`, { role });
  return res.data;
};

export const adminListEmailLogs = async (limit = 100) => {
  const res = await api.get(`/admin/logs/emails?limit=${limit}`);
  return res.data;
};

export const adminEnrichEmailLog = async (id, payload) => {
  const res = await api.patch(`/admin/logs/emails/${id}`, payload);
  return res.data;
};
